import React, {useState} from 'react';

interface DashButtonProps {
  text: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  style?: React.CSSProperties;
}

export const DashButton: React.FC<DashButtonProps> = ({
  text,
  onClick,
  type = 'button',
  style,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const defaultStyle: React.CSSProperties = {
    width: '100%',
    padding: '16px',
    backgroundColor: '#daff00',
    color: '#000',
    border: 'none',
    borderRadius: '8px',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'opacity 0.2s',
    opacity: isHovered ? 0.9 : 1,
    ...style,
  };

  return (
    <button
      type={type}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={defaultStyle}>
      {text}
    </button>
  );
};
